import axios from "axios";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import { toast } from "react-toastify";

class NoteForm extends Component {
  state = {
    loading: false,
    saving: false,
    evaluation: null,
    note: {},
    search: "",
  };

  onEntered = () => {
    if (this.props.evaluationId) {
      this.getNotes(this.props.evaluationId);
    }
  };

  onExit = () => {
    this.setState({
      loading: false,
      saving: false,
      evaluation: null,
      note: {},
      search: "",
    });
  };

  async getNotes(evaluationId) {
    this.setState({ loading: true, evaluation: null, note: {} });

    try {
      const response = await axios.get("evaluations/" + evaluationId);

      if (response.status === 200) {
        this.setState({
          evaluation: response.data,
          loading: false,
        });
      }
    } catch (err) {
      this.setState({ loading: false });

      toast(err.response?.data?.msg || "Erreur lors du chargement des notes.", {
        theme: "light",
        style: { backgroundColor: "red", color: "white" },
      });
    }
  }

  handleInput = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      note: {
        ...prevState.note,
        [name]: value,
      },
    }));
  };

  handleSearch = (e) => {
    this.setState({ search: e.target.value });
  };

  handleCheck(val) {
    const permissions = localStorage.getItem("permissions")
      ? JSON.parse(localStorage.getItem("permissions"))
      : [];

    return permissions.some((item) => val === item.permission);
  }

  getExistingNote(studentId) {
    const { evaluation } = this.state;

    if (!evaluation || !evaluation.notes) return null;

    const found = evaluation.notes.find(
      (data) => data.reportcard.studentId === studentId
    );

    return found ? found.note : null;
  }

  async storeNote() {
    const { evaluation, note } = this.state;

    if (!evaluation) return;

    const students =
      evaluation.schedule.sectionclasselesson.sectionclass.students || [];

    const notes = [];

    students.forEach((student) => {
      const value = note[student.id];

      if (
        value !== undefined &&
        value !== "" &&
        Number(value) >= 0 &&
        Number(value) <= Number(evaluation.max)
      ) {
        notes.push({
          studentId: student.id,
          note: Number(value),
        });
      }
    });

    if (notes.length === 0) {
      toast("Veuillez saisir au moins une note valide.", {
        theme: "light",
        style: { backgroundColor: "orange", color: "white" },
      });
      return;
    }

    this.setState({ saving: true });

    try {
      const response = await axios.post("evaluations/notes", {
        evaluationId: evaluation.id,
        notes,
      });

      toast(response?.data?.msg || "Notes enregistrées avec succès.", {
        theme: "light",
        style: { backgroundColor: "blue", color: "white" },
      });

      this.setState({ saving: false });

      if (this.props.close) this.props.close();
      if (this.props.refresh) this.props.refresh();
    } catch (err) {
      this.setState({ saving: false });

      toast(err.response?.data?.msg || "Erreur lors de l'enregistrement.", {
        theme: "light",
        style: { backgroundColor: "red", color: "white" },
      });
    }
  }

  renderStudents() {
    const { evaluation, note, search } = this.state;

    if (!evaluation) return null;

    let students =
      evaluation.schedule.sectionclasselesson.sectionclass.students || [];

    students = students
      .filter((student) => {
        const text = `${student.matricule} ${student.user.last_name} ${student.user.family_name} ${student.user.first_name}`.toLowerCase();
        return text.includes(search.toLowerCase());
      })
      .sort((a, b) => a.user.last_name.localeCompare(b.user.last_name));

    if (students.length === 0) {
      return (
        <div className="note-form__empty">
          <FeatherIcon icon="users" size={18} />
          <div>Aucun élève trouvé.</div>
        </div>
      );
    }

    return students.map((student, index) => {
      const existingNote = this.getExistingNote(student.id);

      const canAdd =
        this.handleCheck("Ajouter note") === true && existingNote === null;

      const canEdit =
        this.handleCheck("Modifier note") === true && existingNote !== null;

      const canWrite =
        student.yearId === evaluation.schedule.yearId && (canAdd || canEdit);

      return (
        <div key={student.id} className="note-form__student">
          <div className="note-form__student-main">
            <span className="note-form__student-badge">{index + 1}</span>

            <img
              src={student.user.avatar}
              alt=""
              className="note-form__student-avatar"
            />

            <div className="note-form__student-info">
              <div className="fw-bold">
                {student.user.last_name} {student.user.family_name}{" "}
                {student.user.first_name}
              </div>

              <div className="small text-muted">
                {student.matricule} | {student.year ? student.year.year : ""}
              </div>
            </div>
          </div>

          <div className="note-form__student-actions">
            {existingNote !== null && (
              <span className="note-form__chip">
                {existingNote}/{evaluation.max}
              </span>
            )}

            {canWrite ? (
              <input
                type="number"
                name={student.id}
                className="form-control form-control-sm text-center note-form__input"
                value={note[student.id] || ""}
                min="0"
                max={evaluation.max}
                placeholder={`/${evaluation.max}`}
                onChange={this.handleInput}
              />
            ) : (
              <span className="badge bg-light text-muted border">
                Non autorisé
              </span>
            )}
          </div>
        </div>
      );
    });
  }

  render() {
    const { show, close } = this.props;
    const { evaluation, loading, saving, search } = this.state;

    let commitmentDate = "";

    if (evaluation) {
      const date = new Date(
        evaluation.schedule?.date_start || evaluation.createdAt
      );

      commitmentDate =
        date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    }

    return (
      <Modal
        show={show}
        onHide={close}
        onEntered={this.onEntered}
        onExit={this.onExit}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
        scrollable
        dialogClassName="ev-form-dialog note-form-dialog"
        contentClassName="ev-form-modal ev-form-modal--compact note-form-modal"
      >
        <Modal.Header closeButton className="border-0">
          <div className="ev-form-heading">
            <span className="ev-form-heading__icon">
              <FeatherIcon icon="edit-3" size={20} />
            </span>
            <div>
              <span className="ev-form-heading__eyebrow">Saisie des notes</span>
              <Modal.Title className="fw-bold">
                {evaluation?.schedule?.sectionclasselesson?.lesson?.entitled_lesson || "Évaluation"}
              </Modal.Title>
              {evaluation && (
                <div className="small text-muted mt-1">
                  {evaluation.schedule?.periode?.id}P - {evaluation.schedule?.sectionclasselesson?.sectionclass?.class?.short_entitled_class} {evaluation.schedule?.sectionclasselesson?.sectionclass?.title} {evaluation.schedule?.sectionclasselesson?.sectionclass?.section?.short_entitled_section} • Max {evaluation.max}
                </div>
              )}
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="row ev-form-body note-form__body">
          {loading && (
            <div className="col-12">
              <div className="text-center py-5">
                <FeatherIcon className="user-search-spin" icon="loader" />
                <div className="small text-muted mt-2">
                  Chargement des notes...
                </div>
              </div>
            </div>
          )}

          {!loading && evaluation && (
            <>
              <div className="col-12 ev-form-section d-none">
                <span>
                  <FeatherIcon icon="users" size={16} />
                </span>
                <div>
                  <strong>Élèves à noter</strong>
                  <small>Recherchez un élève puis saisissez sa note</small>
                </div>
              </div>

              <div className="col-12 d-none">
                <div className="card border-0 shadow-sm rounded-4 mb-3">
                  <div className="card-body py-2">
                    <div className="input-group input-group-sm">
                      <span className="input-group-text bg-white">
                        <FeatherIcon icon="search" size={15} />
                      </span>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Rechercher un élève..."
                        value={search}
                        onChange={this.handleSearch}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex justify-content-between px-2 mb-2 small fw-bold text-muted">
                  <span>Élèves</span>
                  <span>Points</span>
                </div>

                <div className="note-form__list">{this.renderStudents()}</div>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer className="border-0">
          <span className="ev-form-footer-note">
            <FeatherIcon icon="info" size={14} />
            Les champs marqués d’un * sont obligatoires
          </span>
          <button
            type="button"
            className="btn btn-light ev-form-button"
            onClick={close}
            disabled={saving}
          >
            <FeatherIcon icon="x" size={16} />
            Annuler
          </button>

          <button
            type="button"
            className="btn btn-primary ev-form-button"
            onClick={() => this.storeNote()}
            disabled={saving || loading}
          >
            {saving ? (
              <>
                <FeatherIcon icon="loader" size={15} className="me-1" />
                Enregistrement...
              </>
            ) : (
              <>
                <FeatherIcon icon="check-square" size={15} className="me-1" />
                Sauvegarder
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default NoteForm;